import React, { useCallback, useEffect, useRef, useState } from "react";
import "./CheckboxDropDown.css";
import { Globals as Oldglobals } from "../../global/Globals";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../../components/Loader/Loader";
import { useLanguage } from "../../context/Languagecontext";

const CheckboxDropDown = ({
  title,
  isOpen,
  options,
  onToggle,
  onSelectAll,
  onSelect,
  selectedValues,
  selectedItems,
  dropdownRef,
  isDatePicker,
  isCreatedBy,
  selectedMonthYear,
  selectedMonthYearText,
  onDateChange,
  zIndex,
  width,
  className,
  outerDivClassName,
  longInputText = false,
  isClosingDate,
  oneWordText = false,
  fontColor, //for assign dropdow selected value color change
  search,
  singleSelect,
  wordWrapLimit = 10
}) => {
  const [visibleOptions, setVisibleOptions] = useState([]);

  const { Globals } = useLanguage();

  const [searchText, setSearchText] = useState("");

  const isSearching = searchText.trim() !== "";

  const multiLang = localStorage.getItem("lang");

  const isAllSelected = !isDatePicker
    ? isSearching
      ? visibleOptions.length > 0 && visibleOptions.length === selectedValues.length
      : options.length > 0 && options.length === selectedValues.length
    : "";

  const selectedValuesAsNumbers = isCreatedBy
    ? selectedValues
    : !isDatePicker
    ? selectedValues.map((value) => Number(value))
    : "";

  const getDisplayText = () => {
    if (isDatePicker) {
      return selectedMonthYearText.length > 0 ? selectedMonthYearText : title;
    }

    if (!selectedItems?.length) {
      return title;
    }

    if (longInputText) {
      return selectedItems.length > 2
        ? `${selectedItems[0]},${selectedItems[1]}, + ${selectedItems.length - 2}`
        : selectedItems.join();
    }

    if (oneWordText) {
      return selectedItems.length > 1
        ? `${selectedItems[0]}, + ${selectedItems.length - 1}`
        : selectedItems.join();
    }

    const formatItems = (limit) => {
      const displayedText =
        selectedItems[0].length > limit
          ? selectedItems[0].substring(0, limit) + "..."
          : selectedItems[0];
      return selectedItems.length > 1
        ? `${displayedText} + ${selectedItems.length - 1}`
        : displayedText;
    };
    return selectedItems.length === 1 ? formatItems(wordWrapLimit) : formatItems(8);
  };

  //add present year data in dropwdown Uncomment this data
  const today = new Date();
  const currentYear = new Date().getFullYear();
  const minDate = new Date(currentYear, 0); // Jan of current year
  const maxDate = isClosingDate ? new Date(today.getFullYear(), today.getMonth() + 6) : new Date();
  const debounceTimeout = useRef(null);

  const [itemsToShow, setItemsToShow] = useState(100);
  const containerRef = useRef(null);

  useEffect(() => {
    if (options && searchText.trim().length < 3) {
      setVisibleOptions(options.slice(0, itemsToShow));
    }
  }, [itemsToShow, options]);

  const handleScroll = () => {
    const container = containerRef.current;
    if (searchText.trim().length < 3) {
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
        // Load next 100 if available
        if (itemsToShow < options.length) {
          setItemsToShow((prev) => prev + 100);
        }
      }
    }
  };

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchText(value);

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        if (value.trim() === "") {
          setVisibleOptions(options.slice(0, itemsToShow));
        }else if (value.trim().length >= 3) {
          const filtered = options.filter((option) =>
            option.name.toLowerCase().includes(value.toLowerCase())
            //option.name.toLowerCase().startsWith(value.toLowerCase())
          //option.name.toLowerCase().split(' ').some(word => word.startsWith(value.toLowerCase())) // Check if any word startsWith(query)
          );
          setVisibleOptions(filtered);
        }
         else {
         // If less than 3 characters, show limited/default results or empty
         setVisibleOptions(options.slice(0, itemsToShow));
        }
      }, 300); // Adjust debounce delay (300ms here) as needed
    },
    [options]
  );

  const onDropdownClick = () => {
    onToggle();
    if (options) {
      setVisibleOptions(options.slice(0, itemsToShow));
    }
    setSearchText(""); // Clear search text when toggling dropdown
  };

  return (
    <div
      className={`dropdown ${className} ${outerDivClassName} ${
        selectedItems && selectedItems.length > 0 ? "SelectedFilters" : ""
      } ${selectedMonthYearText && selectedMonthYearText.length > 0 ? "SelectedFilters" : ""}`}
      ref={dropdownRef}
      style={{ zIndex: zIndex }}
    >
      <div className="dropdown-title" onClick={onDropdownClick}>
        <div className={`${fontColor && fontColor} checkbox-title checkboxtitile-${multiLang}`}>{getDisplayText()}</div>
        <div className="dropdown-img">
          <img
            className="dropdown-img"
            src={isDatePicker ? Globals.IMG.CALENDER_ICON : Globals.IMG.DROPDOWN}
          />
        </div>
      </div>

      {isOpen && !isDatePicker && (
        <div
          className={`dropdown-content ${className}`}
          style={{ width: width }}
          // onScroll={handleScroll}
          ref={containerRef}
        >
          {search && (
            <div className="searchBox-wrapper">
              <div className="searchBox_dropdown">
                <input
                  type="text"
                  placeholder={Globals.SEARCH_MIN_3_CHAR}
                  className="searchInput_dropdown"
                  value={searchText}
                  onChange={handleSearch}
                />
                
                {/* Commented the code
                <div className="searchIcon" onClick={handleSearch}>
                  <img className="search_dropdown_icon" src={Globals.IMG.SEARCH} />
                </div> */}
              </div>
            </div>
          )}


          <div className="dropdownItem-warpper"  onScroll={handleScroll}>
            {visibleOptions.length > 1 && !singleSelect ? (
              <div key={"Select-All"} className="dropdownItem">
                <input
                  type="checkbox"
                  id="selectall"
                  value="SelectAll"
                  className="filter_checkbox"
                  checked={isAllSelected}
                  onChange={() =>
                    onSelectAll(!isAllSelected, searchText.trim() === "" ? options : visibleOptions)
                  }
                />
                <label htmlFor="Select All" className="option-label">
                 {Globals.CHECKDROPDOWN.SELECTALL}
                </label>
              </div>
            ) :""}
            {/* <div className="dropdown-seperator"></div> */}

            { visibleOptions.length >= 1 ? 
            visibleOptions.map((option) => (
              <div key={option.Id ?? option.reasonId} className="dropdownItem">
                <input
                  type="checkbox"
                  id={option.id ?? option.reasonId}
                  value={option.id ?? option.reasonId}
                  className="filter_checkbox"
                  checked={singleSelect ? selectedValues?.includes(option.id) : selectedValuesAsNumbers.includes(option.id ?? option.reasonId)}
                  onChange={() => {
                    if (singleSelect) {
                      onSelect(option); // Send array with only one selected
                    } else {
                      onSelect(option); // Multiselect: toggle logic
                    }
                  }}
                />
                <label htmlFor={option} className="option-label">
                  {option.name || option.reasonName}
                </label>
              </div>
            )) : (searchText.trim() === "" && <div className="loaderdropdown"> <Loader height={50} width={50} /> </div>)}
            {searchText.trim() !== "" && visibleOptions.length === 0 && (
              <div className="filter-search-no-results dropdownItem">{Globals.CHECKDROPDOWN.NORESULTFOUND}</div>
            )}
          </div>
        </div>
        //  )
      )}
      {isOpen && isDatePicker && (
        <div className="drownDownDatepick">
          <div className="month-pick">
            <DatePicker
              selected={
                selectedMonthYear && selectedMonthYear.length > 0
                  ? new Date(selectedMonthYear.split(",")[1], selectedMonthYear.split(",")[0] - 1)
                  : null
              }
              onChange={(date) => onDateChange(date)}
              showMonthYearPicker
              placeholderText={Globals.SELECT_MONTH_YEAR}
              maxDate={maxDate}
              inline
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckboxDropDown;
